import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["translations"];
import React from 'react';
import { ErrorScreen } from './ErrorScreen';
import { NoResultsScreen } from './NoResultsScreen';
import { ResultsScreen } from './ResultsScreen';
import { StartScreen } from './StartScreen';
export var ScreenState = React.memo(function (_ref) {
  var _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {} : _ref$translations,
    props = _objectWithoutProperties(_ref, _excluded);
  if (props.state.status === 'error') {
    return /*#__PURE__*/React.createElement(ErrorScreen, {
      translations: translations === null || translations === void 0 ? void 0 : translations.errorScreen
    });
  }
  var hasCollections = props.state.collections.some(function (collection) {
    return collection.items.length > 0;
  });
  if (!props.state.query) {
    return /*#__PURE__*/React.createElement(StartScreen, _extends({}, props, {
      hasCollections: hasCollections,
      translations: translations === null || translations === void 0 ? void 0 : translations.startScreen
    }));
  }
  if (hasCollections === false) {
    return /*#__PURE__*/React.createElement(NoResultsScreen, _extends({}, props, {
      translations: translations === null || translations === void 0 ? void 0 : translations.noResultsScreen
    }));
  }
  return /*#__PURE__*/React.createElement(ResultsScreen, props);
}, function areEqual(_prevProps, nextProps) {
  // We don't update the screen when Autocomplete is loading or stalled to
  // avoid UI flashes:
  //  - Empty screen → Results screen
  //  - NoResults screen → NoResults screen with another query
  return nextProps.state.status === 'loading' || nextProps.state.status === 'stalled';
});